import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UploadedFile } from '../../remote/types/responses';

interface UploadState {
    uploadedResources: UploadedFile[];
}

const initialState: UploadState = {
    uploadedResources: [],
};

const uploadSlice = createSlice({
    name: 'upload',
    initialState,
    reducers: {
        setUploadedResources: (state, action: PayloadAction<UploadedFile[]>) => {
            state.uploadedResources = action.payload;
        },
        addUploadedResource: (state, action: PayloadAction<UploadedFile>) => {
            state.uploadedResources.push(action.payload);
        },
        removeUploadedResource: (state, action: PayloadAction<string>) => {
            state.uploadedResources = state.uploadedResources.filter(
                (resource) => resource.fileId !== action.payload
            );
        },
    },
});

export const { setUploadedResources, addUploadedResource, removeUploadedResource } = uploadSlice.actions;
export default uploadSlice.reducer;